import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { Outlet } from 'react-router-dom'
import { CommercialActivityRoute } from '@/routes/admin/types/pages/CommercialActivity.route'
import { CompanyRelationRoute } from '@/routes/admin/types/pages/CompanyRelation.route'
import { MeetingRoute } from '@/routes/admin/types/pages/Meeting.route'
import { PackageDurationRoute } from '@/routes/admin/types/pages/PackageDuration.route'
import { PaymentRoute } from '@/routes/admin/types/pages/Payment.route'
import { ProblemRoute } from '@/routes/admin/types/pages/Problem.route'
import { QSLicenseRoute } from '@/routes/admin/types/pages/QSLicense.route'
import { SupportRoute } from '@/routes/admin/types/pages/Support.route'
import { TicketRoute } from '@/routes/admin/types/pages/Ticket.route'
import { TicketEventRoute } from '@/routes/admin/types/pages/TicketEvent.route'
import { FatturazioneInterventoRoute } from '@/routes/admin/types/pages/FatturazioneIntervento.route'
import { RapportoRoute } from '@/routes/admin/types/pages/Rapporto.route'
import { ExpenseRoute } from '@/routes/admin/types/pages/Expense.route'
import { DumpRoute } from '@/routes/admin/types/pages/Dump.route'
import { DumpEventRoute } from '@/routes/admin/types/pages/DumpEvent.route'
import { PhoneSupportRoute } from '@/routes/admin/types/pages/PhoneSupport.route'

export const TypesRoute: TileRoleRoute = {
  path: 'types',
  text: 'Tipologie',
  element: (
    <>
      <Outlet />
    </>
  ),
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  tile: true,
  children: [
    CommercialActivityRoute,
    CompanyRelationRoute,
    MeetingRoute,
    PackageDurationRoute,
    PaymentRoute,
    ProblemRoute,
    QSLicenseRoute,
    SupportRoute,
    PhoneSupportRoute,
    TicketRoute,
    TicketEventRoute,
    FatturazioneInterventoRoute,
    RapportoRoute,
    ExpenseRoute,
    DumpRoute,
    DumpEventRoute,
  ],
}
